import {
  borderLinesToCss,
  borderRadiusToCss,
  borderToSx,
} from "./borderUtils";
import { hasBorderRadius } from "./cellStyleUtils";
import { layoutGridWidthPercent } from "../utils/layoutStyleUtils";

/** Inline CSS for wcp-layout-inner (preview + final HTML). */
export const buildLayoutInnerStyleCss = (props) => {
  const widthPercent = layoutGridWidthPercent(props);
  const lines = borderLinesToCss(props?.border);
  const radius = borderRadiusToCss(props?.border);
  const parts = [
    "box-sizing: border-box;",
    `width: ${widthPercent}%;`,
    "max-width: 100%;",
    "font-size: 14px;",
    "line-height: 1.5;",
    lines ? `${lines};` : "",
    radius ? `${radius};` : "",
    props?.backgroundColor ? `background-color: ${props.backgroundColor};` : "",
    props?.padding ? `padding: ${props.padding};` : "",
  ];

  if (hasBorderRadius(props?.border)) {
    parts.push("overflow: hidden;");
  }

  return parts.filter(Boolean).join(" ").replace(/\s+/g, " ").trim();
};

/** React inline style for the inner layout box in the canvas. */
export const buildLayoutInnerCanvasStyle = (props) => {
  const widthPercent = layoutGridWidthPercent(props);
  const style = {
    ...borderToSx(props?.border),
    display: "block",
    boxSizing: "border-box",
    width: `${widthPercent}%`,
    maxWidth: "100%",
    fontSize: 14,
    lineHeight: 1.5,
    margin: 0,
  };

  if (props?.padding) {
    style.padding = props.padding;
  }
  if (props?.backgroundColor) {
    style.backgroundColor = props.backgroundColor;
  }
  if (hasBorderRadius(props?.border)) {
    style.overflow = "hidden";
  }

  return style;
};
 